import * as React from "react";
import { SVGProps, memo } from "react";

const SvgSheet = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.228 12.88a.75.75 0 1 0 0-1.5H7.91a.75.75 0 0 0 0 1.5h4.317Z" fill="#63BA8E" />

    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.385 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h11.23a1 1 0 0 0 1-1V7.302a1 1 0 0 0-.285-.699l-4.207-4.302A1 1 0 0 0 11.408 2H4.385Zm10.73 14.5V9.063h-4.838V3.5H4.886v13h10.23Zm0-8.994v.057h-3.338v-3.47l3.338 3.413Z"
      fill="#63BA8E"
    />
  </svg>
);

const Memo = memo(SvgSheet);

export default Memo;
